define('session',['backbone'], function(Backbone) {
   'use strict';
    var Session = Backbone.Model.extend({
      defaults: {
        logged_in: false
      }
    });
    var session = new Session();
    return session;
});
